var _path, _path2, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoBarcodeCrossd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 14,
    viewBox: "0 0 21 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.55557 14V8.55557H3.11113V14H1.55557ZM3.8889 14V8.55557H5.44446V14H3.8889ZM6.22223 14V8.55557H7.00001V14H6.22223ZM8.55556 14V8.55557H10.1111V14H8.55556ZM10.8889 14V8.55557H13.2222V14H10.8889ZM14 14V8.55557H14.7778V14H14ZM16.3333 14V8.55557H18.6667V14H16.3333Z",
    fill: "#D94C44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.55557 5.44443V0H3.11113V5.44443H1.55557ZM3.8889 5.44443V0H5.44446V5.44443H3.8889ZM6.22223 5.44443V0H7.00001V5.44443H6.22223ZM8.55556 5.44443V0H10.1111V5.44443H8.55556ZM10.8889 5.44443V0H13.2222V5.44443H10.8889ZM14 5.44443V0H14.7778V5.44443H14ZM16.3333 5.44443V0H18.6667V5.44443H16.3333Z",
    fill: "#D94C44"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 6.2222,
    width: 20.2222,
    height: 1.55555,
    fill: "#D94C44"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoBarcodeCrossd);
export default __webpack_public_path__ + "static/media/ico-barcode-crossd.c7e1bba70fb6452cc78071051085583b.svg";
export { ForwardRef as ReactComponent };